import { openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-58cb62e2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "spinner"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  return _openBlock(), _createElementBlock("div", {
    id: "lanch",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.triggerIntercom && _ctx.triggerIntercom.apply(_ctx, arguments);
    })
  }, [_ctx.loading ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : (_openBlock(), _createBlock(_component_SvgIcon, {
    key: 1,
    iconContent: _ctx.iconContent,
    iconAlt: _ctx.iconAlt,
    iconStyle: _ctx.iconStyle
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"]))]);
}